// Support Ticket Assignment & Closure Management (Ifour Admin work item 25961).
// Values mirror PlusDoctor.Business.Enums.SupportTicketStatus / SupportTicketPriority exactly
// (d:\Projects\PlusPhysio-Core\PlusDoctor\Business\PlusDoctor.Business\Enums\SupportTicketEnums.cs) —
// keep these two enums in sync with that file if the backend ever adds/renumbers a value.
export enum TicketStatus {
  New = 1,
  Assigned = 2,
  InProgress = 3,
  Pending = 4,
  Resolved = 5,
  Closed = 6,
  Reopened = 7
}

export const TicketStatusLabels: Record<TicketStatus, string> = {
  [TicketStatus.New]: 'New',
  [TicketStatus.Assigned]: 'Assigned',
  [TicketStatus.InProgress]: 'In Progress',
  [TicketStatus.Pending]: 'Pending',
  [TicketStatus.Resolved]: 'Resolved',
  [TicketStatus.Closed]: 'Closed',
  [TicketStatus.Reopened]: 'Reopened'
};

// Only 6 badge colour classes exist app-wide (badge-success/danger/info/secondary/primary are
// global in styles.css; badge-warning is added locally in tickets.component.css using the same
// --warn-* tokens styles.css already defines for Kendo). Two statuses intentionally share
// badge-secondary (Assigned/Closed) since neither is "in danger" nor "actively worked".
export const TicketStatusBadgeClass: Record<TicketStatus, string> = {
  [TicketStatus.New]: 'badge-info',
  [TicketStatus.Assigned]: 'badge-secondary',
  [TicketStatus.InProgress]: 'badge-primary',
  [TicketStatus.Pending]: 'badge-warning',
  [TicketStatus.Resolved]: 'badge-success',
  [TicketStatus.Closed]: 'badge-secondary',
  [TicketStatus.Reopened]: 'badge-danger'
};

export enum TicketPriority {
  Emergency = 1,
  High = 2,
  Normal = 3,
  Low = 4
}

export const TicketPriorityLabels: Record<TicketPriority, string> = {
  [TicketPriority.Emergency]: 'Emergency',
  [TicketPriority.High]: 'High',
  [TicketPriority.Normal]: 'Normal',
  [TicketPriority.Low]: 'Low'
};

export const TicketPriorityBadgeClass: Record<TicketPriority, string> = {
  [TicketPriority.Emergency]: 'badge-danger',
  [TicketPriority.High]: 'badge-warning',
  [TicketPriority.Normal]: 'badge-info',
  [TicketPriority.Low]: 'badge-secondary'
};

// Legal SupportTicketService.UpdateStatusAsync transitions (IsLegalWorkTransition), mirrored here
// so the "Update Status" dialog only ever offers a target status the backend will actually accept.
// New/Resolved/Closed/Reopened have no legal UpdateStatus target — New/Reopened must go through
// Assign first (which auto-advances New/Reopened -> Assigned), and Resolved/Closed only move via
// the separate Manager-only Close/Reopen endpoints.
export const TICKET_LEGAL_NEXT_STATUSES: Partial<Record<TicketStatus, TicketStatus[]>> = {
  [TicketStatus.Assigned]: [TicketStatus.InProgress, TicketStatus.Pending],
  [TicketStatus.InProgress]: [TicketStatus.Pending, TicketStatus.Resolved],
  [TicketStatus.Pending]: [TicketStatus.InProgress, TicketStatus.Resolved]
};
